import AppState from 'AppState';
import * as React from 'react';
import { Input, InputGroup, Label } from 'reactstrap';
import { toKebabCase } from 'util/StringUtil';
import TooltipWrapper from '../tooltip/TooltipWrapper';
import AutoSuggestContext, { AutoSuggestContextValue } from './AutoSuggestContext';
import AutoSuggestInputActions from './AutoSuggestInputActions';
import { AutoSuggestRenderInputProps } from './Types';

/**
 * Renders the input fields for a user to enter values to search within the AutoSuggest.
 *
 * @class AutoSuggestInput
 * @extends {React.Component<{}>}
 */
class AutoSuggestInput extends React.Component<AutoSuggestRenderInputProps> {
	public static contextType: React.Context<any> = AutoSuggestContext;
	public declare context: AutoSuggestContextValue;

	public static defaultProps = {
		labelVisible: true,
		forceEmptyLabel: false,
		clearable: true,
	};

	/**
	 * Display the list of results on focus.
	 *
	 * @memberof AutoSuggestInput
	 */
	public handleOnFocus = () => {
		const {
			autoSuggestOptions: { expandOnClick = true },
			downshift: { toggleMenu },
		} = this.context;

		if (expandOnClick) {
			toggleMenu();
		}
	};

	public render() {
		const {
			name,
			downshift: { getInputProps, getLabelProps },
		} = this.context;

		const labelProps = getLabelProps();

		const {
			label,
			placeholder,
			disabled,
			forceEmptyLabel,
			clearable,
			testId,
			tooltipText,
			nameValue = '',
			tooltipData,
			entityDefinition,
			hasTooltipError = false,
			downshiftRootProps,
		} = this.props;

		const isTooltipEditMode = AppState.user.isTooltipEditMode;

		// eslint-disable-next-line no-unused-vars
		const { type, ref, ...inputProps } = getInputProps({ name, 'aria-labelledby': `label-${labelProps.id}` });

		return (
			<>
				<Label htmlFor={name} {...labelProps} className={forceEmptyLabel ? 'visually-hidden' : ''}>
					<span className="form-label-icon-wrapper">
						<span className="form-label-text">{label}</span>

						{tooltipText !== undefined && tooltipText !== null && tooltipData && entityDefinition ? (
							<div className="tooltip__row">
								<TooltipWrapper
									hasTooltipError={hasTooltipError}
									tooltipText={tooltipText}
									nameValue={nameValue}
									isTooltipEditMode={isTooltipEditMode}
									tooltipData={tooltipData}
									entityDefinition={entityDefinition}
									label={this.props.label}
								/>
							</div>
						) : null}
					</span>
				</Label>
				<InputGroup>
					<div className="input-wrapper__input-box-wrapper" {...downshiftRootProps}>
						<Input
							className="form-control--cancel-next"
							type="text"
							autoComplete="new-password"
							placeholder={placeholder || 'Begin typing to search...'}
							onFocus={this.handleOnFocus}
							invalid={false}
							disabled={disabled}
							data-testid={testId || `field-${toKebabCase(name)}`}
							onKeyPress={(e) => {
								e.key === 'Enter' && e.preventDefault();
							}}
							{...inputProps}
						/>
					</div>

					<AutoSuggestInputActions clearable={clearable} name={name} disabled={disabled} />
				</InputGroup>
			</>
		);
	}
}

export default AutoSuggestInput;
